import React, { useState } from 'react';
import './Commands.css';

function Commands() {
  const [activeCategory, setActiveCategory] = useState('basics');

  const categories = {
    basics: {
      label: 'Basics',
      icon: '1',
      commands: [
        { cmd: 'git init', desc: 'Inicialitzar un repositori Git nou a la carpeta actual', example: '$ cd el-meu-projecte\n$ git init\nInitialized empty Git repository' },
        { cmd: 'git clone <url>', desc: 'Clonar un repositori remot al teu ordinador', example: '$ git clone https://github.com/user/repo.git\nCloning into \'repo\'...' },
        { cmd: 'git status', desc: 'Veure lestat actual dels fitxers (modificats, nous, staged...)', example: '$ git status\nOn branch main\nChanges not staged for commit:\n  modified: index.html' },
        { cmd: 'git add <fitxer>', desc: 'Afegir fitxers a la staging area per preparar el commit', example: '$ git add index.html\n$ git add .  # afegir tots els fitxers' },
        { cmd: 'git commit -m "msg"', desc: "Crear un commit amb els canvis de la staging area", example: '$ git commit -m "afegir navegacio"\n[main a3f7b21] afegir navegacio\n 1 file changed, 15 insertions(+)' },
      ],
    },
    remote: {
      label: 'Remot',
      icon: '2',
      commands: [
        { cmd: 'git remote add origin <url>', desc: 'Connectar el teu repo local amb un repo remot', example: '$ git remote add origin https://github.com/user/repo.git' },
        { cmd: 'git push', desc: 'Pujar els commits locals al repositori remot', example: '$ git push origin main\nWriting objects: 100% (5/5)\nTo github.com:user/repo.git' },
        { cmd: 'git pull', desc: 'Descarregar i fusionar canvis del remot al local', example: '$ git pull origin main\nUpdating e9c4d18..a3f7b21\nFast-forward\n index.html | 5 ++---' },
        { cmd: 'git fetch', desc: 'Descarregar canvis del remot sense fusionar', example: '$ git fetch origin\nFrom github.com:user/repo\n   e9c4d18..a3f7b21  main -> origin/main' },
      ],
    },
    branching: {
      label: 'Branques',
      icon: '3',
      commands: [
        { cmd: 'git branch', desc: 'Llistar totes les branques locals', example: '$ git branch\n* main\n  feature-login\n  develop' },
        { cmd: 'git branch <nom>', desc: 'Crear una branca nova', example: '$ git branch feature-navbar' },
        { cmd: 'git checkout <branca>', desc: 'Canviar a una altra branca', example: '$ git checkout feature-login\nSwitched to branch \'feature-login\'' },
        { cmd: 'git checkout -b <nom>', desc: 'Crear i canviar a una branca nova (drecera)', example: '$ git checkout -b feature-footer\nSwitched to a new branch \'feature-footer\'' },
        { cmd: 'git merge <branca>', desc: 'Fusionar una branca amb la branca actual', example: '$ git checkout main\n$ git merge feature-login\nMerge made by the \'ort\' strategy.' },
      ],
    },
    history: {
      label: 'Historial',
      icon: '4',
      commands: [
        { cmd: 'git log', desc: "Veure l'historial de commits", example: '$ git log --oneline\na3f7b21 afegir navegacio\ne9c4d18 corregir login\nb2a1f05 commit inicial' },
        { cmd: 'git diff', desc: 'Veure les diferencies entre fitxers modificats', example: '$ git diff\n- <h1>Hola</h1>\n+ <h1>Benvingut</h1>' },
        { cmd: 'git show <hash>', desc: 'Veure els detalls dun commit concret', example: '$ git show a3f7b21\ncommit a3f7b21\nAuthor: Alumne\nDate: Mon Apr 6\n\n  afegir navegacio' },
        { cmd: 'git log --graph', desc: "Veure l'historial amb diagrama de branques", example: '$ git log --graph --oneline\n* a3f7b21 afegir navegacio\n|\\  \n| * e9c4d18 feature-login\n|/\n* b2a1f05 commit inicial' },
      ],
    },
  };

  const [expandedCmd, setExpandedCmd] = useState(null);

  return (
    <section id="comandos" className="commands">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Referencia</span>
          <h2 className="section-title">Comandes <span className="gold">essencials</span></h2>
          <p className="section-desc">
            Les comandes mes importants que necessites coneixer per treballar amb Git.
          </p>
        </div>

        <div className="commands-layout">
          <div className="category-tabs">
            {Object.entries(categories).map(([key, cat]) => (
              <button
                key={key}
                className={`category-tab ${activeCategory === key ? 'active' : ''}`}
                onClick={() => { setActiveCategory(key); setExpandedCmd(null); }}
              >
                <span className="tab-icon">{cat.icon}</span>
                <span className="tab-label">{cat.label}</span>
              </button>
            ))}
          </div>

          <div className="commands-list">
            {categories[activeCategory].commands.map((c, i) => (
              <div
                key={i}
                className={`command-card ${expandedCmd === i ? 'expanded' : ''}`}
                onClick={() => setExpandedCmd(expandedCmd === i ? null : i)}
              >
                <div className="command-main">
                  <code className="command-name">{c.cmd}</code>
                  <p className="command-desc">{c.desc}</p>
                  <svg className="expand-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="6 9 12 15 18 9"/>
                  </svg>
                </div>
                {expandedCmd === i && (
                  <div className="command-example">
                    <div className="mini-terminal">
                      {c.example.split('\n').map((line, j) => (
                        <div key={j} className={`terminal-line ${line.startsWith('$') ? '' : 'output'}`}>
                          {line.startsWith('$') ? (
                            <>
                              <span className="prompt">$</span>
                              <span className="cmd">{line.substring(2)}</span>
                            </>
                          ) : (
                            <span className="output-text">{line}</span>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Commands;
